import React, { Component } from 'react'
import ChatBot from 'react-simple-chatbot'
import { flatten } from 'lodash'

// Utils
import botImg from '../assets/images/ai.png'
import hanks from '../assets/images/hanks.gif'
import { es, fr, eng, ptg } from '../textApp/textTrad'
import { navigationGA } from '../data/GA'

// Components
import Header from './header'
import Custom from './csBubbleImg'

class Chatbot extends Component {
  constructor(props) {
    super(props)

    this.state = {
      named: '',
      brand: '',
      editing: false,
      load: 2,
    }
    this.selectLang = this.selectLang.bind(this)
    // this.redirect = this.redirect.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleName = this.handleName.bind(this)
    this.selection = this.selection.bind(this)
    this.handleSave = this.handleSave.bind(this)
    this.saveData = this.saveData.bind(this)
    this.handleEnd = this.handleEnd.bind(this)
    this.thishandleNext = this.handleNext.bind(this)
  }
  // redirect = () => {
  //   const { navigate, params, user } = this.props
  //   if (!params.id || !params.lng || !user) {
  //     navigate('/')
  //   }
  // }
  static getDerivedStateFromProps(props, state) {
    const { analytics } = props
    navigationGA(analytics.name, analytics.path, analytics.location)
    return null
  }

  selectLang = () => {
    const { lng } = this.props
    switch (lng) {
      case 'es':
        return es
      case 'fr':
        return fr
      case 'en':
        return eng
      case 'pt':
        return ptg
      default:
        return eng
    }
  }
  handleChange = (e, name) => {
    const steped = this.state[name + '_']
    const curState = this.state[name]
    this.setState({
      [name]: steped ? curState : e,
    })
    return true
  }
  handleClick = (name) => {
    this.setState({
      [name]: true,
    })
  }
  handleName = (e) => {
    // console.log('loading name')
    this.setState({
      named: e,
    })
    const user = JSON.parse(localStorage.getItem('dataUser'))
    localStorage.setItem('dataUser', JSON.stringify({ ...user, name: e }))
    return true
  }
  valuetext = (value) => {
    return `${value}°C`
  }
  selection = (e) => {
    this.setState({
      brand: e,
    })
  }
  saveData = (e) => {
    const { survAnsw } = this.props
    this.handleNext()
    // console.log('Saved')
    this.setState({
      load: 1,
    })
    //////////////// Saving localData ////////////////
    const { brand } = this.props
    const { named } = this.state
    const name = named.split(' ')
    const fName = named ? name[0] : ''
    const lName = named ? name[1] : ''
    const userBef = JSON.parse(localStorage.getItem('dataUser'))
    localStorage.setItem(
      'dataUser',
      JSON.stringify({
        ...survAnsw,
        ...userBef,
        name: named,
        fName: fName,
        lName: lName,
        brand: brand,
      })
    )
    //////////////// Saving localData ////////////////
  }
  handleSave() {
    this.setState({
      editing: true,
    })
    // this.saveData()
  }
  handleNext() {
    this.props.handleNext(2)
  }
  handleEnd = (e) => {
    const user = JSON.parse(localStorage.getItem('dataUser'))
    localStorage.setItem(
      'dataUser',
      JSON.stringify({
        ...user,
        endBot: true,
      })
    )

    const { survAnsw, setAns, navigate, location } = this.props
    setAns({ ...survAnsw, name: user.name, endBot: true })

    navigate('/end' + location.search)
    this.handleNext(3)
    // localStorage.removeItem('dataUser')
  }

  render() {
    const { list, txt, sectionShow, user } = this.props
    const brandSel = this.props.brand
    const img = botImg

    // Google Analytcs Page View

    //////////////////////////////////////////////////////////////////
    /////////////////////// Chabot Conversation ///////////////////////
    //////////////////////////////////////////////////////////////////

    var steps1 = [
      {
        id: 'start',
        asMessage: true,
        component: <img className='hanks' src={hanks} alt='' />,
        trigger: '1',
      },
      {
        id: '1',
        message: txt.hello1 + ' ' + user + txt.hello2,
        trigger: '2',
        delay: 500,
      },
      {
        id: '2',
        options: [{ value: 1, label: txt.start, trigger: '6' }],
      },
      // {
      //   id: '3',
      //   message: txt.name,
      //   trigger: '4',
      //   delay: 300,
      // },
      // {
      //   id: '4',
      //   message: txt.worry,
      //   trigger: '6',
      //   delay: 300,
      // },
      // {
      //   id: 'name',
      //   user: true,
      //   validator: this.handleName,
      //   trigger: '6',
      // },
      {
        id: '6',
        component: <Custom type='name' txt={txt} />,
        trigger: '13',
        delay: 300,
      },
      // {
      //   id: '7',
      //   message: txt.gender,
      //   trigger: 'gender',
      //   delay: 300,
      // },
      // {
      //   id: 'gender',
      //   options: [
      //     {
      //       value: 'masculino',
      //       label: txt.genA,
      //       trigger: '9',
      //     },
      //     { value: 'femenino', label: txt.genB, trigger: '9' },
      //     { value: 'noBinary', label: txt.genC, trigger: '9' },
      //   ],
      //   // delay: 300,
      // },
      // {
      //   id: '9',
      //   component: <Custom type='gender' txt={txt} />,
      //   trigger: '10',
      // },
      // {
      //   id: '10',
      //   message: txt.age,
      //   trigger: 'age',
      // },
      // {
      //   id: 'age',
      //   options: [
      //     {
      //       value: 1,
      //       label: '18-25',
      //       trigger: '12',
      //     },
      //     { value: 2, label: '26-35', trigger: '12' },
      //     { value: 3, label: '36-50', trigger: '12' },
      //     { value: 4, label: '50+', trigger: '12' },
      //   ],
      // },
      // {
      //   id: '12',
      //   message: txt.look,
      //   trigger: '13',
      // },
      {
        id: '13',
        message: txt.brand + ' ' + brandSel.toUpperCase(),
        trigger: '18',
        delay: 400,
      },
      {
        id: '18',
        message: txt.thinkBrand,
        trigger: '19',
        delay: 400,
      },
      {
        id: '19',
        message: txt.nextQ,
        trigger: 'startBrand',
        delay: 500,
      },

      {
        id: 'startBrand',
        options: [
          // SELECT RANDOM SECTION
          {
            value: 'yes',
            label: txt.startBrandA,
            trigger: list[0][0]['id'],
          },
          { value: 'no', label: txt.startBrandB, trigger: '20' },
        ],
      },
      {
        id: '20',
        message: txt.backSoon,
        trigger: '19',
      },

      /////////////////////////////
      /// END SURVEY ///
      /////////////////////////////
      {
        id: 'end',
        options: [
          // SELECT RANDOM SECTION
          {
            value: 'yes',
            label: txt.continue,
          },
        ],
        end: true,
      },
    ]

    //////////////////////////////////////////////////////////////////
    /////////////////////// STEPS  MEDIUM ///////////////////////
    //////////////////////////////////////////////////////////////////

    var stepsMed = [
      {
        id: 'startMed',
        message: txt.startMed,
        trigger: 'recall',
      },
      {
        id: 'recall',
        message: txt.recall,
        trigger: 'startBrand',
      },
      {
        id: 'startBrand',
        options: [
          // SELECT RANDOM SECTION
          {
            value: 'yes',
            label: txt.goMed,
            trigger: list[0][0]['id'],
          },
        ],
      },
      {
        id: 'preEnd',
        component: <Custom type='goodBye' txt={txt} />,
        end: true,
        delay: 300,
      },
      {
        id: 'end',
        options: [
          // SELECT RANDOM SECTION
          {
            value: 'save',
            label: txt.save,
          },
        ],
        end: true,
      },
    ]

    /////////////////////////////
    /// JOIN QUESTIONS & DEFAULT STEPS///
    /////////////////////////////
    const botDialog = sectionShow === 1 ? steps1 : stepsMed
    const steps2 = flatten([...botDialog, flatten(list)])

    /////////////////////////////
    ////// STYLING CHATBOT //////
    /////////////////////////////
    const bubble = {
      width: '80%',
      maxWidth: '80%',
      color: '#FFF',
      background:
        'linear-gradient(to right, rgb(0, 77, 205) 5%, rgba(0, 77, 205, 0.6))',
      display: 'flex',
      justifyContent: 'center',
    }
    const bubbleOpt = {
      textDecoration: 'none',
      background: 'rgb(255, 255, 255)',
      color: 'rgb(0, 77, 205)',
      boxShadow: 'rgb(0 77 205) 0px 0px 0px 1.5px',
      cursor: 'pointer',
    }
    return (
      <div className={`mainContainer center ${brandSel}`}>
        <ChatBot
          botDelay={1000}
          handleEnd={sectionShow === 1 ? this.saveData : this.handleEnd}
          className='start'
          botAvatar={img}
          steps={steps2}
          bubbleStyle={bubble}
          headerComponent={<Header props={this} txt={txt} />}
          bubbleOptionStyle={bubbleOpt}
          placeholder={txt.placeholder}
        />
      </div>
    )
  }
}

export default Chatbot
